// extracted by mini-css-extract-plugin
module.exports = {"stepCard":"step-card_stepCard__oCLN1","image":"step-card_image__GEMpw","heading":"step-card_heading__2Lxkm","type":"step-card_type__mbsLg","subSteps":"step-card_subSteps__2AP0o"};